
import React, { useEffect, useState } from "react";
import { useShoppingCart } from "../../../context/CartContext.tsx/ShoppingCartContext";
import AddressForm from "./AddressForm";
import PlaceOrderCTA from "./PlaceOrderCTA";
import CardSkeleton from "../../../components/CardSkeleton";
import CartLoader from "../../../components/CartLoader";
import Popup from "reactjs-popup";

interface AddressModalProps {
  setOpenModal?: React.Dispatch<React.SetStateAction<boolean>>;
  cart_id?: number | any;
  couponCode?: string | any;
}

const AddressModal = ({ setOpenModal, cart_id }: AddressModalProps) => {
  const {
    getCartData,
    getCustomerAddresses,
    getCustomerAddressData,
    openPopup,
    modalOpenData,
    handleAddNewAddress,
    handleEditAddress,
    applyAddress,
    statusData,
    setLoader,
    isCartLoadingData,
    setError,
    gerCartError,
    closePopup,
    setPageData,
    handleSetCheckedAddress,
    checkedAddressData
  } = useShoppingCart();

  const [formOpen, setFormOpen] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState<number | null>(null);
  const [defaultAddress, setDefaultAddress] = useState<number | null>(null);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getCustomerAddresses();
  }, []);

  

  useEffect(() => {
    if (!getCustomerAddressData) {
      getCustomerAddresses();
    } else {
      setIsLoading(false);
      const defaultAddress = getCustomerAddressData.data.find(
        (item: any) => item.is_default === 1
      );
      // console.log(defaultAddress?.id,'defaultAddress');
      setDefaultAddress(defaultAddress ? defaultAddress.id  : null);
    
      // setSelectedAddress(defaultAddress ? defaultAddress.id : null); // Set selectedAddress to defaultAddress's ID if it exists
    }
  }, [getCustomerAddresses, getCustomerAddressData]);




 
  const handleClick = () => {
    // console.log("address Form");
    openPopup("addressForm");
  };

  // console.log(cart_id, checkedAddressData);
  
  const handleSubmit = () => {
    // return;
    if(checkedAddressData){
    applyAddress(cart_id, checkedAddressData);
    }else {
      closePopup();
    }
    // applyAddress('satya', selectedAddress);
  };

  let currentURL = "";
  // Accessing the URL
  currentURL = window.location.href;
  // console.log(currentURL, "thankyou");
  function retryOrder() {
    // Redirect to the previous URL
    window.history.back();
  }

  return (
    <div className="modalBackground">
      <div className="modalContainer">
        <button
          className="popupClose"
          onClick={() => {
            if (modalOpenData.popupId === "checkout") {
              closePopup();
              setPageData(1);
            } else if (currentURL.includes("thankyou")) {
              retryOrder();
              setPageData(1);
            } else {
              closePopup();
            }
          }}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.99032 0.990242C1.79139 0.990294 1.59699 1.04967 1.43198 1.16079C1.26697 1.2719 1.13884 1.4297 1.06399 1.61401C0.98913 1.79832 0.970941 2.00077 1.01175 2.19548C1.05255 2.39018 1.15049 2.56829 1.29305 2.70704L6.58602 8.00001L1.29305 13.293C1.19708 13.3851 1.12046 13.4955 1.06767 13.6176C1.01489 13.7397 0.987001 13.8712 0.985647 14.0042C0.984294 14.1373 1.0095 14.2692 1.05979 14.3924C1.11008 14.5156 1.18444 14.6275 1.27852 14.7216C1.3726 14.8157 1.4845 14.89 1.60768 14.9403C1.73086 14.9906 1.86283 15.0158 1.99587 15.0144C2.12891 15.0131 2.26034 14.9852 2.38247 14.9324C2.5046 14.8796 2.61497 14.803 2.70712 14.707L8.00008 9.41407L13.2931 14.707C13.3852 14.803 13.4956 14.8796 13.6177 14.9324C13.7398 14.9852 13.8713 15.0131 14.0043 15.0145C14.1373 15.0158 14.2693 14.9906 14.3925 14.9403C14.5157 14.89 14.6276 14.8157 14.7217 14.7216C14.8157 14.6275 14.8901 14.5156 14.9404 14.3924C14.9907 14.2692 15.0159 14.1373 15.0145 14.0042C15.0132 13.8712 14.9853 13.7397 14.9325 13.6176C14.8797 13.4955 14.8031 13.3851 14.7071 13.293L9.41415 8.00001L14.7071 2.70704C14.8516 2.56658 14.9503 2.38574 14.9903 2.18822C15.0302 1.9907 15.0096 1.78571 14.931 1.60013C14.8525 1.41454 14.7197 1.25701 14.5501 1.14818C14.3805 1.03935 14.182 0.984302 13.9806 0.990242C13.7208 0.997983 13.4742 1.10656 13.2931 1.29298L8.00008 6.58595L2.70712 1.29298C2.61393 1.19718 2.50248 1.12104 2.37937 1.06904C2.25625 1.01704 2.12396 0.99025 1.99032 0.990242Z"
              fill="#4F4F4F"
            ></path>
          </svg>
        </button>
        <div style={{ paddingBottom: "0px" }}>
          <div className="modalContent_mt" style={{ padding: "25px" }}>
            <div
              className="addressBtn"
              onClick={() => {
                handleAddNewAddress();
                setError();
              }}
            >
              <button className="addNewAddress">Add New Address</button>
              <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.9299 5.92993L20.9999 11.9999L14.9299 18.0699"
                  stroke="#1B1B1B"
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M4 12H20.83"
                  stroke="#1B1B1B"
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
          <div className="addressList" style={{ overflow: "auto" }}>
            {isLoading && <CardSkeleton cards={8} />}

            {getCustomerAddressData &&
              getCustomerAddressData?.data.length > 0 &&
              getCustomerAddressData?.data
                .sort((a: any, b: any) => {
                  if (a.is_default === 1 && b.is_default !== 1) {
                    return -1;
                  } else if (a.is_default !== 1 && b.is_default === 1) {
                    return 1;
                  } else {
                    return 0;
                  }
                })
                .map((item: any) => (
                  <div
                    className="addressCodeWrapper"
                    style={
                      checkedAddressData === item.id ||
                      (checkedAddressData === null && defaultAddress === item.id)
                        ? {
                            background: "#F8FAFC",
                            border: "2px solid #3D6AAE",
                            boxShadow: "0px 2px 4px rgba(102, 102, 102, 0.125)",
                          }
                        : {
                            background: "#FFFFFF",
                            border: "0.4px solid #CCCCCC",
                            boxShadow: "0px 2px 4px rgba(102, 102, 102, 0.125)",
                          }
                    }
                    key={item.id}
                  >
                    <label className="addressListcontainer">
                   
                      <div
                        className="send_addr_html"
                        style={{ marginLeft: "10px" }}
                      >
                        <div className="codeContent">
                          <p className="itemAddressName">{item.first_name}</p>
                          <p className="itemAddress">
                            {`${item.address}, ${item.city}, ${item.province}-${item.zip}, ${item.country}`}
                          </p>
                          {item.phone && (
                            <p className="itemMobile">Mobile: {item.phone}</p>
                          )}
                        </div>
                      </div>
                      <input
                        type="radio"
                        name="address"
                        value=""
                        checked={
                          checkedAddressData === item.id ||
                          (checkedAddressData === null &&
                            defaultAddress === item.id)
                        }
                        onChange={() => handleSetCheckedAddress(item.id)}
                      />
                      <span className="radioAddressCheckmark" />
                    </label>
                    <button
                      className="applyAddressButton"
                      onClick={() => {
                        handleEditAddress(item);
                        setError();
                      }}
                    >
                      Edit Address
                    </button>
                  </div>
                ))}
          </div>
        </div>
        <div className="placeOrder">
          {gerCartError && <div className="errorMessage">{gerCartError}</div>}
          <div style={{ position: "relative" }}>
            {isCartLoadingData && <CartLoader />}

            {/* onClick={() => {
              if (addressFlag === true) {
                onPress(paylod);
                handleClickCheckout();
                setPageData(2);
              } else {
                handleAddNewAddress()
              }
            }} */}

            {/* <form onSubmit={handleSubmit}> */}
            <button

              onClick={() => 
               
                  handleSubmit()
              }

              // onClick={() => {
              //   if (defaultAddress) {
              //     handleSubmit();
              //   } else {
              //     closePopup();
              //   }
              // }}
              className="placeOrderCTA ripple"
              // type="submit"
              disabled={getCustomerAddressData ? false : true}
            >
              <span>Proceed With Selected Address </span>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.4301 5.93005L20.5001 12.0001L14.4301 18.0701"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
                <path
                  d="M3.5 12H20.33"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </button>
            {/* </form> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddressModal;
